export default __webpack_public_path__ + "static/media/Pinterest.f70fa4c7.svg";